import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// interface AlertDialogProps {
//   open: boolean;
//   onClose: () => void;
//   onConfirm: () => void;
//   title: string;
//   description: string;
// }

export default function AlertDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmDisabled = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={confirmDisabled ? undefined : onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
      <Button onClick={onClose} disabled={confirmDisabled} sx={{ background: 'linear-gradient(266.46deg, #5F51DE 0%, #AD5DD3 100%)' }}>
  <span style={{color:'white', fontFamily: "Manrope, Helvetica"}}>No</span>
</Button>
<Button onClick={onConfirm} disabled={confirmDisabled} sx={{ background: 'linear-gradient(266.46deg, #5F51DE 0%, #AD5DD3 100%)'}}>
<span style={{color:'white', fontFamily: "Manrope, Helvetica"}}>Yes</span>
</Button>

      </DialogActions>
    </Dialog>
  );
}